import { action, observable } from 'mobx';

import { AnyObject } from '@estee/elc-universal-utils';

import { SignInType } from '~constants/SignInTypeEnum';

export class SocialSignInState {
    @observable
    public extraParamsCollection: Record<SignInType, AnyObject>;

    constructor() {
        this.extraParamsCollection = {} as Record<SignInType, AnyObject>;
    }

    // Store request params overrides, when the user chooses to try again after landing back to sign-in page -
    // probably with an error message, we will apply them to the request.
    // e.g. https://developers.facebook.com/docs/facebook-login/guides/advanced/manual-flow#reaskperms
    @action
    public setExtraParams = (provider: SignInType, params: AnyObject) =>
        (this.extraParamsCollection[provider] = params);
}
